import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { StudyReportNavbar } from '../../../../analytics/components/StudyReportNavbar';
import { UserMetricsHistorySection } from '../../../../analytics/shared/UserMetricsHistorySection';
import { PageLoader } from '../../../../design/page/PageLoader';
import { IMainLayoutDomainStore } from '../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { AnalyticsPageHeader } from '../main/parts/AnalyticsPageHeader';
import { UserProfileCard } from './UserProfileCard';
import { UserUnitCardsContent } from './UserUnitCardsContent';
import { AnalyticsUserDomain } from './store/AnalyticsUserDomain';
import { AnalyticsUserUI } from './store/AnalyticsUserUI';
import { TranslateText } from '../../../../../application/language/TranslateText';

export const AnalyticsUserPage = observer(({ layoutDomain }: { layoutDomain: IMainLayoutDomainStore }) => {
  const { userId } = useParams<{ userId: string }>();
  const reportArg = useMemo(() => ({ userIds: userId ? [userId] : [] }), [userId]);
  const ui = useMemo(() => new AnalyticsUserUI(new AnalyticsUserDomain(layoutDomain), userId), [layoutDomain, userId]);

  useEffect(() => {
    ui.boot();
  }, [ui]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', height: '100%', minHeight: 0 }}>
      <AnalyticsPageHeader
        breadcrumbs={ui.breadcrumbs.value}
        isFetching={ui.isFetchingUser.value}
        actions={<StudyReportNavbar key={`report-${userId}`} reportArg={reportArg} userMode />}
      />

      {ui.isFetchingUser.value ? (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <PageLoader minHeight="100%" />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flex: 1, minHeight: 0, overflow: 'auto' }}>
          <UserProfileCard
            user={ui.user.value}
            userDetail={ui.userDetail.value}
            progressSummary={ui.progressSummary.value}
          />
          {/* {userId && <UserMetricsHistorySection userId={userId} />} */}
          <Typography variant="h6">
            <TranslateText i18nKey="analytics.userUnitProgress" />
          </Typography>
          <Box >
            <UserUnitCardsContent unitCards={ui.unitCards.list} />
          </Box>
        </Box>
      )}
    </Box>
  );
});
